import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";

export const NODE_TYPES = {
  RFID: 'RFID_V1',
  BLE: 'BLE_V1',
  EVEN_READER: 'EVEN_READER',
}
class NodeTypeSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: 'Tipo do node',
      label: 'name',
      items: [{id: NODE_TYPES.RFID, name: 'RFID'}, {id: NODE_TYPES.BLE, name: 'BLE'}, {id: NODE_TYPES.EVEN_READER, name: 'EVEN READER'}]
    };
  }
}

NodeTypeSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default NodeTypeSelector;



// WEBPACK FOOTER //
// ./src/gateways/node/NodeTypeSelector.js